(function () {
  function countryFlag(code) {
    if (!code || code.length !== 2) return '🌍';
    return String.fromCodePoint.apply(
      String,
      code.toUpperCase().split('').map(function (character) {
        return 127397 + character.charCodeAt(0);
      })
    );
  }

  function enhanceProduct(root) {
    var marker = root.querySelector('.ai-pdp-style-marker');
    if (!marker) return;

    var productInfo = marker.closest('product-info') || root;
    var form = productInfo.querySelector('product-form form[data-type="add-to-cart-form"]');
    var button = form && form.querySelector('.product-form__submit');
    var dataNode = productInfo.querySelector('.ai-pdp-variant-prices');
    if (!form || !button || !dataNode) return;

    var variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var variantMap = {};
    variants.forEach(function (variant) {
      variantMap[String(variant.id)] = variant;
    });

    function updateButton() {
      var input = form.querySelector('input[name="id"]');
      var variant = input && variantMap[String(input.value)];
      var content = button.querySelector('span');
      if (!content || !variant) return;

      if (button.disabled || variant.available === false) {
        if (content.textContent.trim() !== 'SOLD OUT') content.textContent = 'SOLD OUT';
        button.dataset.aiPdpVariantId = String(variant.id);
        return;
      }

      if (
        button.dataset.aiPdpVariantId === String(variant.id) &&
        content.querySelector('.ai-pdp-atc__prices')
      ) {
        return;
      }

      var compareMarkup = variant.compareAtPrice
        ? '<s class="ai-pdp-atc__compare">' + variant.compareAtPrice + '</s>'
        : '';

      content.innerHTML =
        '<span class="ai-pdp-atc__label">ADD TO CART</span>' +
        '<span class="ai-pdp-atc__divider" aria-hidden="true">•</span>' +
        '<span class="ai-pdp-atc__prices">' +
          '<span class="ai-pdp-atc__sale">' + variant.price + '</span>' +
          compareMarkup +
        '</span>';
      button.dataset.aiPdpVariantId = String(variant.id);
    }

    updateButton();

    productInfo.addEventListener('change', function (event) {
      if (!event.target.closest('variant-selects')) return;
      window.setTimeout(updateButton, 0);
      window.setTimeout(updateButton, 250);
    });

    new MutationObserver(updateButton).observe(button, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.ai-pdp-country-flag').forEach(function (node) {
      node.textContent = countryFlag(node.dataset.countryCode);
    });

    if (root.querySelector && root.querySelector('.ai-pdp-style-marker')) {
      enhanceProduct(root);
    } else if (root.querySelectorAll) {
      root.querySelectorAll('product-info').forEach(function (productInfo) {
        enhanceProduct(productInfo);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
